module.exports = __webpack_public_path__ + "media/images/number_1_red-2ca7d47974ea16714d1ce0cc1eeb4196.png";